import { render, staticRenderFns } from "./booking-success.vue?vue&type=template&id=fe551fc6&scoped=true"
import script from "./booking-success.vue?vue&type=script&lang=js"
export * from "./booking-success.vue?vue&type=script&lang=js"
import style0 from "./booking-success.vue?vue&type=style&index=0&id=fe551fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe551fc6",
  null
  
)

export default component.exports